import * as React from "react";
import { MobXProviderContext, observer } from "mobx-react";
import { Box, Checkbox, Grid, Link } from "@material-ui/core";
import { MUIPreloader, themeVariables } from "../../../MUI";
import axios from "axios";
import * as styles from "./styles.scss";
import cx from "classnames";
import InfiniteScroll from "react-infinite-scroller";
import { tl } from "../../../../../utils";

import { IFile } from "../../types";

import { FilecardAll } from "./FilecardAll";
import { FilecardAudio } from "./FilecardAudio";
import { FilecardImage } from "./FilecardImage";
import { FilecardVideo } from "./FilecardVideo";

import { UploadPanel } from "../Head/UploadPanel";
import FSStore from "../../store";
import FSCourseStore from "../store";
import FSViewerStore from "../../Viewer/store";

const locales: any = {
  notfound: {
    search: tl("Не найден ни один файл по вашему запросу, "),
    videoempty: tl("У вас нет видео файлов в хранилище этого курса. "),
    all: tl("У вас нет файлов в хранилище этого курса. "),
    notinlessons: tl(
      "Если вы загрузите файлы в курс и не будете использовать их в уроках курса, мы отобразим их список здесь, "
    ),
    homeworks: tl("В Домашних заданиях нет файлов, "),
    chats: tl("В ваших Чатах нет файлов, "),
  },
};

interface IProps {
  lesson_id?: number;
  person_id?: number;
  chat_id?: number;
  groupedFiles?: Array<IFile>;
  APIUrl?: string;
  simple?: boolean;
  scrollerUseWindow?: boolean;
}

interface IState {
  files: Array<IFile>;
  hasMoreFiles: boolean;
  page: number;
}

export const FilesList = observer((props: IProps) => {
  const { fsStore, fsCourseStore, fsViewerStore } = React.useContext<{fsStore: FSStore, fsCourseStore: FSCourseStore, fsViewerStore: FSViewerStore}>(
    MobXProviderContext
  );

  const [files, setFiles] = React.useState(
    props.groupedFiles ? [...props.groupedFiles] : []
  );
  const [hasMoreFiles, setHasMoreFiles] = React.useState(
    props.simple
      ? false
      : !!props.groupedFiles
      ? props.groupedFiles.length >= fsCourseStore.getFileslistLimit
      : true
  );
  const [startPage, setStartPage] = React.useState(2);

  let _isMounted = true;

  React.useEffect(() => {
    _isMounted = true;
    if (!props.groupedFiles && files.length === 0 && hasMoreFiles) {
      fetchData(false);
    }

    return () => {
      _isMounted = false;
      const tooltips = document.querySelectorAll(".b-tooltip");
      Array.prototype.forEach.call(tooltips, function(node: any) {
        node.parentNode.removeChild(node);
      });
    };
  });

  const fetchData = (isContinue: boolean = true) => {
    const page = isContinue ? startPage : 1;
    if (props.APIUrl) {
      fsStore.setLoading(true);
      let url = props.APIUrl;
      url += `&page=${page}`;
      url += props.lesson_id ? `&lesson_id=${props.lesson_id}` : ``;
      url += props.person_id ? `&student_id=${props.person_id}` : ``;
      url += props.chat_id ? `&chat_id=${props.chat_id}` : ``;
      url += `&limit=${fsCourseStore.getFileslistLimit}`;

      axios
        .get(url, {
          headers: { "X-Requested-With": "XMLHttpRequest" },
          transformResponse: [(response) => JSON.parse(response)],
        })
        .then((response) => {
          if (_isMounted) {
            const newData = response.data;
            const newFiles = [...files];
            const filesTemp = [...newFiles];
            if (newData.files) {
              newData.files.map((file: IFile) => {
                if (
                  !filesTemp.filter((item: IFile) => item.id === file.id).length
                ) {
                  newFiles.push(file);
                }
              });
              setFiles(newFiles);
              setHasMoreFiles(
                newData.files.length >= fsCourseStore.getFileslistLimit
              );
              setStartPage(page + 1);
              fsStore.setLoading(false);
              fsStore.filesCount = newFiles.length;
            } else {
              setHasMoreFiles(false);
              fsStore.setLoading(false);
            }
          }
        });
    }
  };

  const searchLabel =
    fsCourseStore.isSearchNotEmpty && fsCourseStore.filterFilesType === "video"
      ? "videoempty"
      : fsCourseStore.isSearchNotEmpty
      ? "all"
      : fsCourseStore.filesSectionTab === "notinlessons"
      ? "notinlessons"
      : fsCourseStore.filesSection === "notuse" &&
        fsCourseStore.filesSectionTab === "all"
      ? "all"
      : fsCourseStore.filesSection
      ? fsCourseStore.filesSection
      : "search";

  const fileItem = (file: IFile) => {
    file.name = file.name ? file.name.replace("%22", '"') : tl("Без имени");
    const passProps = {
      data: file,
      grouped: props.groupedFiles !== undefined,
      canDelete: fsCourseStore.filesSectionTab === "notinlessons",
      onPreview: (fileId: number, fileCategory: string) => {
        fsViewerStore.showViewer(
          fileId,
          props.simple
            ? fsStore.filesChecked.filter(
                (file: IFile) => file.category === fileCategory
              )
            : files.filter((file: IFile) => file.category === fileCategory)
        );
      },
    };
    if (props.simple) {
      return <FilecardAll key={`fsfile-${file.id}`} {...passProps} simple />;
    }
    return (function(category) {
      switch (category) {
        case "transcription":
          return <FilecardVideo key={`fsfile-${file.id}`} {...passProps} />;
        case "video":
          return <FilecardVideo key={`fsfile-${file.id}`} {...passProps} />;
        case "audio":
          return <FilecardAudio key={`fsfile-${file.id}`} {...passProps} />;
        case "image":
          return <FilecardImage key={`fsfile-${file.id}`} {...passProps} />;
        default:
          return <FilecardAll key={`fsfile-${file.id}`} {...passProps} />;
      }
    })(fsCourseStore.filterFilesType);
  };

  return files.length > 0 || (props.simple && fsStore.filesChecked) ? (
    <Box px={fsCourseStore.isFileslistCarded && !props.simple ? 1 : 0}>
      <Box
        {...(fsCourseStore.isFileslistCarded && !props.simple
          ? { p: 1 }
          : null)}
        className={cx({
          [styles.cards]: fsCourseStore.isFileslistCarded && !props.simple,
          ["infiniteScrollContainer"]:
            !fsCourseStore.isFileslistCarded &&
            !props.simple &&
            (props.groupedFiles || fsStore.isWidget),
          [styles.transcriptions]: fsCourseStore.filterFilesType === 'transcription',
        })}
        bgcolor={
          fsCourseStore.isFileslistCarded && !props.simple
            ? themeVariables.palette.grey.A400
            : undefined
        }
      >
        {props.simple ? (
          fsStore.filesChecked.map((file: any) => fileItem(file))
        ) : (
          <InfiniteScroll
            useWindow={fsCourseStore.filterFilesType === 'transcription' ? false : (!props.groupedFiles && !fsStore.isWidget) || !!props.scrollerUseWindow}
            loadMore={fetchData}
            hasMore={hasMoreFiles}
            initialLoad={false}
            loader={<MUIPreloader key="filestorage-fileslist-preloader" />}
          >
            <Grid
              container
              {...(fsCourseStore.isFileslistCarded && !props.simple
                ? {
                    direction: "row",
                    spacing: 1,
                  }
                : {
                    direction: "column",
                    wrap: "nowrap",
                  })}
              className={
                !fsStore.getCheckedFilesCount
                  ? styles.noCheckedFiles
                  : styles.hasCheckedFiles
              }
            >
              {files.map((file: any) => fileItem(file))}
            </Grid>
          </InfiniteScroll>
        )}
      </Box>
    </Box>
  ) : hasMoreFiles ? (
    <MUIPreloader />
  ) : (
    <Box px={2} py={3} textAlign="center">
      {locales.notfound[searchLabel]}
      {!fsCourseStore.isHaveFilesInCourse ? (
        <Box className={styles.upload}>
          <UploadPanel />
        </Box>
      ) : (
        <>
          <Link
            underline="always"
            onClick={() => {
              fsCourseStore.isSearchNotEmpty
                ? fsCourseStore.resetFilterParamsSoft()
                : fsCourseStore.resetFilterParams();
            }}
          >
            {tl("вернуться в список файлов")}
          </Link>
          .
        </>
      )}
    </Box>
  );
});
